export default __webpack_public_path__ + "static/media/news1.66664450.png";